// intitialize validation settings
ko.validation.init({
    insertMessages: false,
    messageTemplate: null,
    //messagesOnModified: false,
    grouping: { deep: true, observable: true }
}, true);


/*
 * HACK HACK HACK HACK
 * Copied from /Scripts/Sections/valueright/knockout-DynamisExtensions.js
 * 
 */ 
 /* 
 Google Places Autocomplete handler
 autocompleteOptions    = The options to use for the google autocomplete object. Default will be used if not provided
 countryFilter          = Plain javascript or ko observable of the currently selected country by the user to restrict search matches to
 onPlaceChange          = The callback function for when the selected place has changed in the autocomplete drop down
*/
ko.bindingHandlers.addressAutoComplete = {
    init: function (element, valueAccessor, allBindingsAccessor) {

        // Get the value of element and all the bindings
        var value = valueAccessor();
        var allBindings = allBindingsAccessor().addressAutoComplete;

        // Add the autocomplete functionality to the element and pass the options if any are provided, if not an empty object
        var autocomplete = new google.maps.places.Autocomplete(element, allBindings.autocompleteOptions || {});

        // Limit results returned to just be the address components and goemetry for lat and lng (can expand to take these details via binding later)
        autocomplete.setFields(['address_component', 'geometry']);

        // Get the country filter passed in. Only use if populated
        var countryFilter = ko.utils.unwrapObservable(ko.utils.unwrapObservable(allBindings.countryFilter));
        if (countryFilter !== null) {
            var normalisedCountryCode = countryFilter.toLowerCase();
            if (normalisedCountryCode == "uk")
                normalisedCountryCode = "gb";
            autocomplete.setComponentRestrictions({ "country": [normalisedCountryCode] });
        }

        // Call the place changed event handler function provided in the binder and provide it with the places selected as an param
        autocomplete.addListener('place_changed', function () {
            allBindings.onPlaceChange(element, autocomplete.getPlace());
        });

    },
    update: function (element, valueAccessor, allBindingsAccessor) {

        // Get the value of element and all the bindings
        var value = valueAccessor();
        var allBindings = allBindingsAccessor().addressAutoComplete;

        // Add the autocomplete functionality to the element and pass the options if any are provided, if not an empty object
        var autocomplete = new google.maps.places.Autocomplete(element, allBindings.autocompleteOptions || {});

        // Limit results returned to just be the address components and goemetry for lat and lng (can expand to take these details via binding later)
        autocomplete.setFields(['address_component', 'geometry']);

        // Get the country filter passed in. Only use if populated
        var countryFilter = ko.utils.unwrapObservable(ko.utils.unwrapObservable(allBindings.countryFilter));
        if (countryFilter !== null) {
            var normalisedCountryCode = countryFilter.toLowerCase();
            if (normalisedCountryCode == "uk")
                normalisedCountryCode = "gb";
            autocomplete.setComponentRestrictions({ "country": [normalisedCountryCode] });
        }

        // Call the place changed event handler function provided in the binder and provide it with the places selected as an param
        autocomplete.addListener('place_changed', function () {
            allBindings.onPlaceChange(element, autocomplete.getPlace());
        });


    }
};

// Function to tell if a value is null or undefined
function IsObjectNullOrUndefined(input) {
    return input === null || input === undefined;
}

ko.extenders.nullableNumeric = function (target, parametersObj) {

    // Provides the ability bind the nullablenumeric to inputs, but still have them return pure values when the .formatted extension is not used
    target.FormattedValue = ko.pureComputed({
        read: function () {
            var txtInput = target();
            // Returns the value back to the observable in a formatted way with the prepended string first
            return IsObjectNullOrUndefined(txtInput) ? txtInput : parametersObj.prependingString + ' ' + parseFloat(txtInput).toLocaleString();
        },
        write: function (newValue) {
            var current = target();
            var invertValue;

            if (newValue !== null) {
                // Tests to see if the value input was in currency format , i.e (XXX,XXX.XX)
                invertValue = /\((.{1,})\)/g.test(newValue);

                // Strips all formatting from the number to give us a numeric representation
                newValue = newValue.toString().replace(/[^0-9-.]/g, '');//will need all possible characters that can be used in formatting a price included in this regex

                // invert the number if it was entered as an accountancy style
                if (invertValue) { newValue *= -1; }
            }

            //  Do we need to run any additional validation functions and if so does it pass??
            if (!IsObjectNullOrUndefined(parametersObj.additionalIsValidFunction) &&
                !parametersObj.additionalIsValidFunction(newValue)) {
                newValue = parametersObj.additionalModificationFunction(newValue);
            }


            // Check if the new value is categorically numeric
            if (newValue !== null && newValue !== '' && !isNaN(newValue)) {

                var roundingMultiplier = Math.pow(10, parametersObj.precision),
                    newValueAsNum = parseFloat(newValue),
                    valueToWrite = Math.round(newValueAsNum * roundingMultiplier) / roundingMultiplier;

                //only write if it changed
                if (valueToWrite !== current) {
                    target(valueToWrite);
                } else {
                    //if the rounded value is the same, but a different value was written, force a notification for the current field
                    if (newValue !== current) {
                        target.notifySubscribers(valueToWrite);
                    }
                }
            }
            else {
                // Only write if it changed value
                if (newValue !== current) {

                    // check if the current value is null 
                    if (current === null) {
                        // in this case, return undefined, as it will force an update on the target and all subscribers
                        target(undefined);
                    }
                    else {
                        target(null); // Return null as null equates to zero in implicit casts (including the MVC model binder)
                    }

                }
            }
        }
    });

    return target;
};